<template>
  <v-card class="pa-0">
    <card-label-bar bold-text>
      Contact info
      <template v-slot:btn-text>
        <v-btn @click="editInfo" text color="blue"> Edit </v-btn>
      </template>
    </card-label-bar>

    <v-card-text>
      <v-list class="profile__info__wrap">
        <v-list-item
          v-for="(item, index) in contactInfo"
          :key="index"
          three-line
          class="info__item col-12 col-sm-6"
        >
          <v-list-item-content>
            <v-list-item-title class="caption text--secondary">
              {{ contactInfo.mobile.label }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-subtitle-2 text--primary">
              {{ displayContact }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    contactInfo() {
      return this.$store.getters["Profile/contactInfo"];
    },
    displayContact() {
      if (this.contactInfo.mobile.value.number === '') {
        return '-'
      } else {
        return '+\xa0\xa0' + this.contactInfo.mobile.value.areaCode + '\xa0\xa0\xa0\xa0' + this.contactInfo.mobile.value.number
      }
    }
  },

  methods: {
    toggleSideSheet(payload) {
      this.$store.dispatch("SideSheet/toggleSideSheet", payload);
    },

    editInfo() {
      this.toggleSideSheet({ isOn: true, isComponent: "contact-info-form" });
    },
  },
};
</script>

<style lang="sass" scoped>
.profile__info__wrap
	margin: -12px
	padding: 0

	.info__item
		display: inline-flex
		min-height: 32px

		.v-list-item__content
			align-content: flex-start
			align-items: flex-start
			align-self: flex-start
			padding: 0 0 8px
</style>
